import { Component, OnInit } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import { formatDate, DatePipe } from '@angular/common';
import { Md5 } from 'ts-md5/dist/md5'
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'; 

//snackbar 1
import {MatSnackBar} from '@angular/material';
import { duration } from 'moment';
import * as moment from "moment";
import { environment } from "environments/environment";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  user;
  pass;
  
  //queda en local storage
  userGral: string;
  passGral: string;
  fecha_hoy = new Date;
  apellidonombreGral: string;
  roleGral: string;
  seccionalGral: string;
  userOK: boolean = false;
  noti;
  idsec;
  //para pedir que llene preguntas de seguridad
  contadorinicios;
  error;

  constructor(
    private http: HttpClient,
    private datePipe: DatePipe,
    private _router: Router,
    
    //snackbar 2
    public snackBar: MatSnackBar
    
    ) {
      this.error=false;
      localStorage.setItem('logueado', "false"); 
    }
  
  transformDate(date) {
    this.datePipe.transform(this.fecha_hoy, 'yyyy-MM-dd'); //whatever format you need. 
  }
  ngOnInit() {
    window.scroll(0,0);
    this.datePipe.transform(this.fecha_hoy,"yyyy-MM-dd");
  }
role;
  getUser(){
    this.http.get(`${environment.backendUrl}/api/login/datosusuario?userid=${this.user}&pass=${Md5.hashStr(this.pass)}&fechahoy=${this.fecha_hoy}`).subscribe((data: any[]) => {
      //console.log(data[0][0]);
      if (!(data[0][0])){
        console.log("USUARIO O CONTRASEÑA INCORRECTA");
        
        //snackbar si no encuentra al usuario
        this.snackBar.open('Datos Incorrectos, Intente nuevamente..', 'Cerrar', {duration: 4000});

      }else{
        localStorage.setItem('logueado', "true");
        console.log("ENCONTRADO!!!!");
        //cuenta ingresos al sistema
        this.http.get(`${environment.backendUrl}/api/devuelveingresos/contar?userid=${this.user}`).subscribe((ingresos: any[]) => {
          console.log("INGRESOS--->");
          this.contadorinicios=ingresos[0]["INGRESOS"];
          console.log(this.contadorinicios);

          if (this.contadorinicios<1){
            console.log("****lanzar modal!*****");
            localStorage.setItem('userId', data[0][0]["id_usuario"]);
            localStorage.setItem('apellidonombre', data[0][0]["apellidonombre"]);
            localStorage.setItem('role', data[0][0]["rol"]);
            console.log("rol del local storage..");
            console.log(localStorage.getItem('role'));
            this.role=localStorage.getItem('role');
      
            localStorage.setItem('seccional', data[0][0]["id_seccional"]);
            this.idsec=localStorage.getItem('seccional');
            localStorage.setItem('seccdetalle',data[0][0]["descripcion"]);
            localStorage.setItem('userOK',"true");
            localStorage.setItem('pre1be',data[0][0]["pregunta1"]);
            localStorage.setItem('res1be',data[0][0]["respuesta1"]);
            localStorage.setItem('pre2be',data[0][0]["pregunta2"]);
            localStorage.setItem('res2be',data[0][0]["respuesta2"]);
            this.llenarNoti();
            //lanza el modal para pedir preguntas de seguridad..
            this.lanzaModal();
          
          }else{
            //SINO MANDA AL HOME  
            console.log('****va directo al home****');
            localStorage.setItem('userId', data[0][0]["id_usuario"]);
            localStorage.setItem('apellidonombre', data[0][0]["apellidonombre"]);
            localStorage.setItem('role', data[0][0]["rol"]);
            this.role=localStorage.getItem('role');
            console.log("rol del local storage..");
            console.log(localStorage.getItem('role'));
            localStorage.setItem('pre1be',data[0][0]["pregunta1"]);
            localStorage.setItem('res1be',data[0][0]["respuesta1"]);
            localStorage.setItem('pre2be',data[0][0]["pregunta2"]);
            localStorage.setItem('res2be',data[0][0]["respuesta2"]);
            localStorage.setItem('seccional', data[0][0]["id_seccional"]);
            this.idsec=localStorage.getItem('seccional');
            localStorage.setItem('seccdetalle',data[0][0]["descripcion"]);
            localStorage.setItem('userOK',"true");
            this.llenarNoti();
            this.sumaIngreso();
            this._router.navigate(['/home']);
          }
        }); //cierra subscribe de devuelveingresos
        // snackbar si encuentra al usuario
        this.snackBar.open('Logueado Correctamente!', 'Cerrar', {duration: 4000});
      }
    });
  }

  sumaIngreso(){
    //sumo ingreso al sistema (contador en tabla cuenta_ingresos)
    this.http.get(`${environment.backendUrl}/api/cuentaingresos/sumaringreso?userid=${this.user}&fechahoy=${moment(this.fecha_hoy).format('YYYY-MM-DD')}`).subscribe((data: any[]) => {
      this.result3 = JSON.stringify(data["affectedRows"]);
      if (this.result3==1){
        console.log(`sumo un ingreso el usuario: ${this.user}!`);
        //this.snackBar.open(`DATOS ACTUALIZADOS!`, 'Cerrar', {duration: 3000});
      }else{
        console.log(`no se sumo!`);
        }
    });
  }

  login(){
    this.getUser();
    localStorage.setItem('LS_FECHA_HOY',this.datePipe.transform(this.fecha_hoy,"yyyy-MM-dd"));
  }

  lanzaModal(){
    document.getElementById("abremodal").click(); 
  }

pregunta1;
pregunta2;
respuesta1;
respuesta2;
nuevaclave;
result3;
passwd;

actualizarUser(){
  //manda el update con las preguntas y respuestas de seguridad
  //http://localhost:1337/api/actualizauser/sumaringreso
  this.http.get(`${environment.backendUrl}/api/actualizauser/sumaringreso?codus=${this.user}&pre1=${this.pregunta1}&res1=${this.respuesta1}&pre2=${this.pregunta2}&res2=${this.respuesta2}&pas=${Md5.hashStr(this.passwd)}`)
    .subscribe((data: any[]) => {
      this.result2 = JSON.stringify(data["affectedRows"]);
      if (this.result2==1){
        console.log(`USUARIO: ${this.user} securizado CORRECTAMENTE!`);
        
        //piso los datos del usuario como si se estuviera logueando de vuelta
        localStorage.setItem('pre1be',this.pregunta1);
        localStorage.setItem('res1be',this.respuesta1);
        localStorage.setItem('pre2be',this.pregunta2);
        localStorage.setItem('res2be',this.respuesta2);
        this.sumaIngreso();
        this.snackBar.open(`DATOS ACTUALIZADOS!`, 'Cerrar', {duration: 3000});
      }else{
        console.log(`NO SE ACTUALIZARON LOS DATOS`);
      }
      this._router.navigate(['/home']);
  });
}

result;
result2;

blanqueaIngresos(){
  this.error=true;
  //NUEVITO
  this.http.get(`${environment.backendUrl}/api/blanqueaingresos/blanquear?userid=35363906`)
    .subscribe((data: any) => {
      this.result = JSON.stringify(data["affectedRows"]);
      if (this.result==1){
        console.log(`USUARIO: ${this.user} BLANQUEADO CORRECTAMENTE!`);
        //del navbar
        this.llenarNoti();
        this.snackBar.open(`OBLIGADO A CARGAR!!`, 'Cerrar', {duration: 3000});

      }else{
        console.log(`estaba en cero..`)
      }
    });
}

llenarNoti(){
  if (this.role=='PAGADOR'){
    //http://localhost:1337/api/jorgenotifi/noti?est=AUTORIZADO
    this.http.get(`${environment.backendUrl}/api/jorgenotifi/noti?est=AUTORIZADO`)
      .subscribe((data: any[]) => {
      this.noti = data[0]["TOT"]; 
      localStorage.setItem('notipend',this.noti);
      console.log(`noti= ${localStorage.getItem('notipend')}`);   
    });
  }else{
  //http://localhost:1337/api/notifi/noti?idse=21&est=PENDIENTE
  this.http.get(`${environment.backendUrl}/api/notifi/noti?idse=${this.idsec}&est=PENDIENTE`)
    .subscribe((data: any[]) => {
    this.noti = data[0]["TOT"]; 
    localStorage.setItem('notipend',this.noti);
    console.log(`noti= ${localStorage.getItem('notipend')}`); 
  });
  }


}

newpass;
result4;

changePass(){
  console.log("pass cambiada! kpa");
//  http://localhost:1337/api/changepass/change?iduser=USER&pas=ee11cbb19052e40b07aac0ca060c23ee

  this.http.get(`${environment.backendUrl}/api/changepass/change?iduser=${this.user}&pas=${Md5.hashStr(this.newpass)}`)
    .subscribe((data: any[]) => {
      this.result4 = JSON.stringify(data["affectedRows"]);
      if (this.result4==1){
        console.log(`USUARIO: ${this.user} PASS CAMBIADA!!`);
        this.snackBar.open(`PASS CAMBIADA!!`, 'Cerrar', {duration: 3000});

      }else{
        console.log(`user no encontrado..`);
      }

    });


}


}
